import * as React from 'react';
import { Typography, Stack, Button, TextField, Link } from "@mui/material"
import { Storefront } from '../models/StorefrontResponse';
import { APIEndpoint, EndpointType, httpPut } from '../utils/apiService';
import { UsersResponse } from '../models/UsersResponse';
import { useTSGUser } from "../contexts/TSGUserContext";

interface Props {
    storefront: Storefront,
    closeDialogCallback(): void
}

export default function PhoneDialog(props: Props) {
    const [phone, setPhone] = React.useState("");

    const { tsgUser } = useTSGUser();

    const handleRemindMe = () => {
        const payload = {
            acknowledge: "phone-remind"
        }

        const apiURL =  APIEndpoint(EndpointType.Users) + "?customer-id=" + tsgUser?.id
        httpPut(apiURL, JSON.stringify(payload))
        .then((data) => {
            const usersResponse = data as UsersResponse;
            
            if (usersResponse.status == 'error') {
                console.log("Error saving phone-remind acknowledgement for user: " + usersResponse.errorMessage)
            } else {
              console.log("Phone-Remind Acknowledgement saved")
            }
        })
        .catch((error) => { 
          console.error('Phone-Remind Ack Save Error:', error);
        });

        props.closeDialogCallback();
    }

    const handleSubmit = () => {
        const updatedUser = tsgUser;
        updatedUser.phone = phone;

        // If user phone doesn't start with a +, add the country code
        if (updatedUser.phone && !updatedUser.phone.startsWith('+')) {
            updatedUser.phone = "+1" + updatedUser.phone; // Assuming US country code, adjust as necessary
        }

        const apiURL =  APIEndpoint(EndpointType.Users) + "/" + tsgUser.id
        httpPut(apiURL, JSON.stringify(updatedUser))
        .then((data) => {
            const usersResponse = data as UsersResponse;
            
            if (usersResponse.status == 'error') {
                console.log("Error updating phone for user: " + usersResponse.errorMessage)
            } else {
              console.log("User Phone updated successfully")
            }
        })
        .catch((error) => { 
          console.error('User Phone Save Error:', error);
        });

        props.closeDialogCallback();
    }


    return (
        <Stack spacing={2} sx={{m:2}}>
            <Typography variant="h5" color={props.storefront.activeColors.mainPage.pageText}>Let’s Complete Your Profile</Typography>
            <Typography color={props.storefront.activeColors.mainPage.pageText}>Please enter your phone number to complete your profile. This helps us reach you with critical lead updates and support when needed.</Typography>
            <Stack direction="row" spacing={2}>
                <TextField id="phone" label="Phone" value={phone} sx={{ width: 300, mt: 2, mb: 1 }} onChange={(e) => setPhone(e.target.value)} ></TextField>
            </Stack>
            
            <Stack direction="row" alignItems="center" spacing={2}>
                <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                <Link onClick={handleRemindMe} sx={{ cursor: 'pointer', color: props.storefront.activeColors.mainPage.pageText }}>Remind me later</Link>
            </Stack>
        </Stack>
    )
}